import Page from "./Page";
import permissions from "app/permissions";

export const resources = {
  isMenu: false,
  name: "student/individual-curriculum",
  custom: <Page />,
  permission: permissions.canManageStudentsIndividualCurriculums,
};
